import { ErrorModelTabsContent } from '@oliasoft/error-models-gui';
import { IIPMFile, IPMFileType } from 'common/interfaces/settings';

interface JSONViewerProps {
  dataObject: IIPMFile;
}

// Extract logic in wd to npm package or just copy for now
export const IPMFileViewer = ({ dataObject }: JSONViewerProps) => {
  if (dataObject.type === IPMFileType.Folder) {
    return;
  }

  return (
    <ErrorModelTabsContent
      localErrorModels={[dataObject as any]}
      isModuleDisabled={true}
      selectedErrorModelId={dataObject.id}
      onChangeErrorModelValue={() => {}}
    />
  );
};
